import { FunctionComponent, useState } from "react";
import { Icon } from "@animech/ui";
import { CheckBoxPropagateColor } from "../checkbox-propagate-color";
import * as Styled from "./color-picker.style";

export type ColorPickerColor = {
	value: string;
	label: string;
	image?: string;
	outOfStock?: boolean;
	invertColors?: boolean;
};

interface ColorPickerProps {
	visible?: boolean;
	position?: { x: number; y: number };
	colors?: ColorPickerColor[];
	selectedColor?: ColorPickerColor;
	canDelete?: boolean;
	onColorSelect?: (color: ColorPickerColor) => void;
	onMove?: () => void;
	onDelete?: () => void;
}

export const ColorPicker: FunctionComponent<ColorPickerProps> = ({
	visible,
	position = undefined,
	colors = [],
	selectedColor,
	canDelete,
	onColorSelect,
	onDelete,
}) => {
	const [internalSelectedColor, setInternalSelectedColor] =
		useState<ColorPickerColor>(selectedColor || colors[0]);

	const currentSelectedColor = selectedColor || internalSelectedColor;

	const handleColorSelect = (color: ColorPickerColor) => {
		setInternalSelectedColor(color);
		onColorSelect?.(color);
	};

	return (
		<Styled.ColorPicker
			position={position}
			visible={visible}
			canDelete={canDelete}
			invertColors={currentSelectedColor.invertColors}
		>
			<Styled.ColorWheel count={colors.length}>
				{colors.map((color, index) => (
					<Styled.ColorWheelOption
						key={index}
						index={index}
						image={color.image}
						selected={currentSelectedColor.value === color.value}
						onClick={() => handleColorSelect(color)}
						disabled={!!color.outOfStock}
					/>
				))}
			</Styled.ColorWheel>
			<Styled.MiddleSection image={currentSelectedColor.image}>
				<Styled.Label>{currentSelectedColor.label}</Styled.Label>
				<Styled.Trash onClick={onDelete}>
					<Icon name="trashcan" scale={1.1} />
				</Styled.Trash>
			</Styled.MiddleSection>
			<Styled.CheckBox>
				<CheckBoxPropagateColor />
			</Styled.CheckBox>
		</Styled.ColorPicker>
	);
};
